import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navItems, site } from '@/mocks/site';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const isActive = (to: string) => (to === '/' ? location.pathname === '/' : location.pathname.startsWith(to));

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-background-200'
          : 'bg-background-50 border-transparent'
      }`}
    >
      <div className="flex h-[72px] w-full items-center justify-between px-4 md:px-8">
        <Link to="/" className="flex items-center gap-3 group" aria-label="爆料看点 首页">
          <span className="w-10 h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-xl font-bold">
            爆
          </span>
          <span className="flex flex-col">
            {isHome ? (
              <h1 className="font-heading text-lg font-bold leading-tight text-foreground-950">{site.name}</h1>
            ) : (
              <span className="font-heading text-lg font-bold leading-tight text-foreground-950">{site.name}</span>
            )}
            <span className="font-label text-[10px] tracking-[0.32em] text-foreground-500">{site.enName}</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8" aria-label="主导航">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`relative font-label text-sm transition-colors ${
                isActive(item.to)
                  ? 'text-primary-600 font-medium'
                  : 'text-foreground-700 hover:text-primary-600'
              }`}
            >
              {item.label}
              {isActive(item.to) && (
                <span className="absolute -bottom-1.5 left-0 h-[2px] w-full rounded-full bg-primary-500" />
              )}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/dossiers"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-compasses-2-line text-base" />
            进入档案库
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-900"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-5 pt-3">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-md px-3 py-3 font-label text-sm transition-colors ${
                  isActive(item.to) ? 'bg-primary-50 text-primary-700' : 'text-foreground-800 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
          <Link
            to="/dossiers"
            className="mt-3 flex items-center justify-center gap-2 rounded-md bg-foreground-950 px-4 py-3 font-label text-sm text-background-50"
          >
            <i className="ri-compasses-2-line text-base" />
            进入档案库
          </Link>
        </div>
      )}
    </header>
  );
}